export const TOUR_ID = 'e-town';

const MAPPING_GROUP_ID_ROUTE = {
  'tong-the-1-21210386': { groupId: '', sceneName: 'front-view' },
  'tong-the-2-b8c72600': { groupId: '', sceneName: 'side-view' },
  'tong-the-3-7210ad5e': { groupId: '', sceneName: 'tong-the-3' },
  'skybar-4c3dc91e': { groupId: 'amenities', sceneName: 'skybar' },
  'function-room-6c83e602': {
    groupId: 'amenities',
    sceneName: 'function-room',
  },
  'tieu-canh-qjday-timeos-53d7120c': {
    groupId: 'amenities',
    sceneName: 'landscape-feature-day-time',
  },
  'drop-off-94bbec43': { groupId: 'amenities', sceneName: 'drop-off' },
  'sanh-jkday-timekj-8263fa8f': {
    groupId: 'amenities',
    sceneName: 'san-day-time',
  },
  'sanh-zanight-timeyr-2852f9c4': {
    groupId: 'amenities',
    sceneName: 'san-night-time',
  },
  'loi-vao-phong-gym-d9d9fd74': {
    groupId: 'amenities',
    sceneName: 'hallways-outside-sky-gym',
  },
  'steam-bath-entrance-0ecadd0a': {
    groupId: 'amenities',
    sceneName: 'steam-bath-entrance',
  },
  'xong-hoi-icsteambathud-2a982423': {
    groupId: 'amenities',
    sceneName: 'steam-bath',
  },
  'sky-gym-eo-meditation-c6f8ef2a': {
    groupId: 'amenities',
    sceneName: 'sky-gym-meditation',
  },
  'swimming-pool-rooftop-693ccbbe': {
    groupId: 'amenities',
    sceneName: 'swimming-pool-rooftop',
  },
  'galgallery-igfood-courtkg-7942bd48': {
    groupId: 'amenities',
    sceneName: 'gallery-food-court',
  },
  'food-court-f24ff949': {
    groupId: 'amenities',
    sceneName: 'food-court',
  },
  'thang-may-11d12b8c': {
    groupId: 'amenities',
    sceneName: 'elevator',
  },
  'tieu-canh-hqnight-timeun-08790b0e': {
    groupId: 'amenities',
    sceneName: 'landscape-feature-night-time',
  },
  'garden-sunken-garden-24ed0418': {
    groupId: 'amenities',
    sceneName: 'above-sunken-garden',
  },
  'garden-sunken-garden-bcnightzf-f60311d1': {
    groupId: 'amenities',
    sceneName: 'sunken-garden',
  },
};

export const getGroupIdFromRoute = (route) => {
  return MAPPING_GROUP_ID_ROUTE[route];
};

export const getRouteKeyBySceneName = (sceneName) => {
  if (!sceneName) return undefined;
  for (const [key, value] of Object.entries(MAPPING_GROUP_ID_ROUTE)) {
    if (value && value.sceneName === sceneName) {
      return key;
    }
  }
  return undefined;
};
